/**
 * Provides JS functionality for wysiwyg display.
 */
class Wysiwyg extends DrupalBehavior {

  onContent(context) {
    $('.paragraph--type--wysiwyg').find('table').each((index, table) => {
      if(!$(table).parent().hasClass('wysiwyg__table-wrapper')) {
        const wrapper = $('<div></div>').addClass('wysiwyg__table-wrapper');
        wrapper.append($(table).clone());
        $(table).replaceWith(wrapper);
      }
    });
  }

}

DrupalBehavior.register('camc.components', 'wysiwyg', Wysiwyg);
